(function () {
    'use strict';

    angular
        .module('franchisee.components', []);

    angular
        .module('franchisee.directives', []);

    angular
        .module('franchisee.filters', []);

    angular
        .module('franchisee.interceptors', []);

    angular
        .module('franchisee.routes', []);

    angular
        .module('franchisee.services', []);

    angular
        .module('franchisee.constants', []);
}());